import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { supabase } from '../utils/supabaseClient';

export default function AcceptShare() {
  const [sp] = useSearchParams();
  const token = sp.get('token');
  const [msg, setMsg] = useState('Checking your invite...');

  useEffect(() => {
    (async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) { setMsg('Please sign in to accept the invite.'); return; }

      const res = await fetch('/api/invites/email-share/accept', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${session.access_token}` },
        body: JSON.stringify({ token })
      });
      const out = await res.json();
      if (!res.ok) setMsg(out.error || 'Failed to accept invite.');
      else setMsg('Invite accepted! You can now view their email.');
    })();
  }, [token]);

  return <div className="p-6">{msg}</div>;
}
